module.exports = __webpack_public_path__ + "static/team-35-00406dc1b103e15da931a4aef92f2fd1.jpg";